module.exports = __webpack_public_path__ + "img/bottomimg.2d57ea1b.png";